import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Radio,
  Divider,
  InputAdornment,
  FormControl,
  FormLabel,
  RadioGroup,
  FormHelperText,
  Grid,
  Chip,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import SelectDropdown from "../Components/SelectDropdown/SelectDropdown";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "./YourProfile.css";
import {
  fetchGetDropdownValuesAPICall,
  startOverAPICall,
  stageDetailsAPICall,
  NRIProfileDetailsAPICall,
  CommonDropDownAPICall,
} from "../shared/APICalls";
import {
  INRIProfileDetails,
  IYourProfileDetails,
  IYourProfilePrefillData,
} from "../shared/dtos";
import routesData from "../shared/routes.json";
import ProfileStyles from "../pages/Styles/YourProfile.module.scss";
import KRAFetchedDetails from "./KRAFetchedDetails";
import StageLayout from "../Layouts/StageLayout";
import icon from "../Components/assets/Images/iconnew.svg";
import jwt_decode from "jwt-decode";
import BackDrop from "../Components/BackDrop";
import Dropdown from "../Components/SelectDropdown/DropDown";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/profileicongrey.svg";
import backicon from "../Components/assets/Images/back.svg";
import CommonDropdown from "../Components/SelectDropdown/CommonDropDown";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import { useDispatch } from "react-redux";
import PloiticalModal from "../Components/Modals/PoliticalModal/PoliticalModal";

const politicallyExposed = [
  {
    id: "no",
    sequence: 1,
    value: "No",
  },
  {
    id: "yes",
    sequence: 2,
    value: "Yes",
  },
];

const maritalStatus = [
  {
    id: "single",
    sequence: 1,
    value: "Single",
  },
  {
    id: "married",
    sequence: 2,
    value: "Married",
  },
  {
    id: "others",
    sequence: 3,
    value: "Others",
  },
];
const Gender = [
  {
    id: "male",
    sequence: 1,
    value: "Male",
  },
  {
    id: "female",
    sequence: 2,
    value: "Female",
  },
  {
    id: "others",
    sequence: 3,
    value: "Others",
  },
];

const schema = Yup.object().shape({
  fatherFullName: Yup.string()
    .required("Father Name is Required")
    .min(3, "Minmum 3 letters is required")
    .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .max(50)
    .transform((value: any) => value && value.toUpperCase()),

  motherFullName: Yup.string()
    .required("Mother Name is Required")
    .max(50)
    .min(3, "Minmum 3 letters is required")
    .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .transform((value: any) => value && value.toUpperCase()),
  annualIncome: Yup.object().required("Please select an option"),
  tradingExperience: Yup.object().required("Please select an option"),
  occupation: Yup.object().required("Please select an option"),
  occupationIfOthers: Yup.string()
    .nullable()
    .when("occupation", (occupation, schema) => {
      if (
        Array.isArray(occupation) &&
        occupation.length > 0 &&
        occupation[0]?.value === "Others"
      ) {
        return schema
          .required("Please Enter Occupation Others")
          .matches(/^[a-zA-Z ]*$/, "Enter a valid occupation")
          .min(3, "Minimum 3 letters are required")
          .max(50, "Maximum 50 characters allowed")
          .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed");
      }
      return schema.notRequired();
    }),

  areYouPoliticallyExposed: Yup.object().required("Please select an option"),
  maritalStatus: Yup.object().required("Marital Status is required"),
  gender: Yup.object().required("Gender is required"),
});

export default function YourProfilePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //Loaders
  const [loading, setloading] = useState(false);
  const [prefilloading, setprefilloading] = useState(true);
  const [occupationOthers, setOccupationOthers] = useState<any>();
  const [occupationOther, setOthersDataFeild] = useState<any>();
  const [dropDownData, setDropDownData] = useState<any>({});
  const [annualDropDownData, setAnnualDropDownData] = useState<any>([]);
  const [tradingExperienceDropdownData, settradingExperienceDropdownData] =
    useState<any>([]);
  const [occupationDropdownData, setoccupationDropdownData] = useState<any>([]);
  const [displayFatherNameField, setdisplayFatherNameField] =
    useState<any>(true);

  const [editUpdates, setEditUpdates] = useState<any>(true);
  const [startOverloading, setstartOverloading] = useState(false);

  const [prefillData, setprefillData] = useState<IYourProfilePrefillData>({
    fatherFullName: "",
    motherFullName: "",
    annualIncome: "",
    tradingExperience: "",
    occupation: "",
    areYouPoliticallyExposed: "",
    maritalStatus: "",
    gender: "",
    occupationIfOthers: "",
  });
  const [noeditableData, setnoEditableData] = useState<any>([]);
  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [openModal, setopenModal] = useState(false);
  const navigationData = routesData;
  const [user, setUser] = useState({});

  function setOthersData(data: any) {
    // console.log(data.target.value.value);

    setOthersDataFeild(data);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);
    let annualFetchedData;
    let tradingFetchedData;
    let OccupationFetchedData;
    setprefilloading(true);
    let dd_type = "profile";
    CommonDropDownAPICall(dd_type)
      .then((response: any) => {
        const responseData = response.data.data;

        setAnnualDropDownData(
          responseData.annual_income
            .map((a: any) => {
              return a;
            })
            .sort((a: any, b: any) => a.sequence - b.sequence)
        );
        annualFetchedData = responseData.annual_income.map((a: any) => {
          return a;
        });

        settradingExperienceDropdownData(
          responseData.trading_exp
            .map((a: any) => {
              return a;
            })
            .sort((a: any, b: any) => a.sequence - b.sequence)
        );

        tradingFetchedData = responseData.trading_exp.map((a: any) => {
          return a;
        });
        setoccupationDropdownData(
          responseData.occupation.map((a: any) => {
            return a;
          })
        );

        OccupationFetchedData = responseData.occupation.map((a: any) => {
          return a;
        });

        // API Call
        let obj: any = {
          stage: "customer_details",
        };

        stageDetailsAPICall(obj)
          .then((response: any) => {
            setprefilloading(false);
            setEditUpdates(false);
            const responseData = response.data;

            dispatch(setCompletedStages(responseData.data.completed_stages));
            dispatch(setCurrentStage(responseData.data.current_stage));

            const annualIncomeReturned = annualFetchedData.filter(
              (data: any) => data.value === responseData.data.data.annual_income
            )[0];
            const tradingExperienceReturned = tradingFetchedData.filter(
              (data: any) => data.value === responseData.data.data.trading_exp
            )[0];
            const occupationReturned = OccupationFetchedData.filter(
              (data: any) =>
                data.value === responseData.data.data.occupation.occ_value
            )[0];

            setRejectMessage(responseData.data.ErrorMessage);
            setOthersDataFeild(
              responseData.data.data.occupation.occ_value === "Others"
                ? "Others"
                : responseData.data.data.occupation.others_value
            );
            setprefillData((prev) => {
              return {
                ...prev,
                fatherFullName: responseData.data.data.father_name,
                motherFullName: responseData.data.data.mother_name,
                annualIncome: annualIncomeReturned ? annualIncomeReturned : "",
                maritalStatus:
                  responseData.data.data.marital_status === "single"
                    ? maritalStatus[0]
                    : responseData.data.data.marital_status === "married"
                    ? maritalStatus[1]
                    : responseData.data.data.marital_status === "others"
                    ? maritalStatus[2]
                    : "",
                areYouPoliticallyExposed:
                  responseData.data.data.political_exposed === true
                    ? politicallyExposed[1]
                    : responseData.data.data.political_exposed === false
                    ? politicallyExposed[0]
                    : "",
                tradingExperience: tradingExperienceReturned
                  ? tradingExperienceReturned
                  : "",
                gender:
                  responseData.data.data.gender === "male"
                    ? Gender[0]
                    : responseData.data.data.gender === "female"
                    ? Gender[1]
                    : responseData.data.data.gender === "others"
                    ? Gender[2]
                    : "",
                occupation: occupationReturned ? occupationReturned : "",
                occupationIfOthers:
                  responseData.data.data.occupation.others_value,

                // settlements: preferenceType ? preferenceType : Settlements[0],
              };
            });
          })
          .catch((error: any) => {
            setprefilloading(false);
            setdisplayFatherNameField(true);
            //  console.log("error", error);
          });
      })
      .catch((error: any) => {
        setprefilloading(false);
        // console.log("error", error);
      });
  }, []);

  // console.log("annualDropDownData",annualDropDownData)

  const annualIncomeOptions = annualDropDownData;
  const tradingExperienceOptions = tradingExperienceDropdownData;
  const occupationOptions = occupationDropdownData;

  function yourProfile(data: any) {
    if (data.areYouPoliticallyExposed.id === "yes") {
      setopenModal(true);
    } else {
      setloading(true);
      let obj: any = {
        marital_status: data.maritalStatus.id,
        father_name: data.fatherFullName.toUpperCase(),
        mother_name: data.motherFullName.toUpperCase(),
        annual_income: data.annualIncome.value,
        trading_exp: data.tradingExperience.value,
        gender: data.gender?.id,
        occupation: data.occupation.value,
        occupation_others:
          occupationOther === "Others"
            ? data.occupationIfOthers.toUpperCase()
            : "",
        politically_exposed: data.areYouPoliticallyExposed.id,
      };
      NRIProfileDetailsAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          // console.log(responseData);
          setloading(false);
          if (
            responseData.data.next_stage &&
            navigationData.hasOwnProperty(responseData.data.next_stage)
          ) {
            navigate(navigationData[responseData.data.next_stage]);
          }
        })
        .catch((error: any) => {
          setloading(false);
        });
    }
  }

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            setstartOverloading(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                // console.log("responseData", response);
                setstartOverloading(false);
                setBackDrop(false);
                navigate("/");
                window.location.reload();
              })
              .catch((error: any) => {
                setBackDrop(false);
                setstartOverloading(false);
              });
          },
        },
      ],
    });
  };
  const initialValues: IYourProfilePrefillData = {
    fatherFullName: prefillData.fatherFullName,
    motherFullName: prefillData.motherFullName,
    annualIncome: prefillData.annualIncome,
    tradingExperience: prefillData.tradingExperience,
    occupation: prefillData.occupation,
    areYouPoliticallyExposed: prefillData.areYouPoliticallyExposed,
    maritalStatus: prefillData.maritalStatus,
    gender: prefillData.gender,
    occupationIfOthers:
      prefillData.occupationIfOthers === null
        ? ""
        : prefillData.occupationIfOthers,
    // settlements: prefillData.settlements,
  };

  const handleDone = () => {
    setopenModal(false);
  };

  //console.log("prefillData" , prefillData)

  return (
    <div className={ProfileStyles.mainWrapper}>
      <ErrorSnackBar message={rejectMessage} />
      {backdrop && <StartOverBackDrop />}
      <div className={ProfileStyles.wrapper}>
        <div
          className={ProfileStyles.backTop}
          onClick={() => {
            navigate("/panverification");
          }}
        >
          <img src={backicon} />{" "}
          <span className={ProfileStyles.backText}>Back</span>
        </div>
        <div className={ProfileStyles.step}>
          <img src={keyboardicon} /> Step 3 of 10
        </div>
        <div className={ProfileStyles.leftContainer}>
          <div className={ProfileStyles.headerSection}>
            <p className={ProfileStyles.signup}>Share A Bit About Yourself</p>
          </div>
          {!prefilloading ? (
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={(values: any) => {
                // console.log("values", values);
                yourProfile(values);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => {
                // console.log("values", values);
                return (
                  <form
                    noValidate
                    onSubmit={handleSubmit}
                    onKeyDown={(event) => {
                      event.code === "Enter" && handleSubmit();

                      // event.code.includes("Enter") && handleSubmit()
                    }}
                  >
                    <div className={ProfileStyles.contentWrapper}>
                      <div className={ProfileStyles.topContainer}>
                        <div className={ProfileStyles.textFeildWrapper}>
                          {displayFatherNameField && (
                            <TextField
                              className={ProfileStyles.textfield}
                              id="outlined-basic"
                              label="Father's Full Name"
                              variant="outlined"
                              name="fatherFullName"
                              value={
                                values.fatherFullName &&
                                values.fatherFullName.toUpperCase()
                              }
                              error={
                                touched.fatherFullName &&
                                Boolean(errors.fatherFullName)
                              }
                              helperText={
                                touched.fatherFullName &&
                                errors.fatherFullName?.toString()
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              inputProps={{
                                sx: {
                                  "&::label": {
                                    fill: "#111827",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                  },
                                  color: "var(--Black-Black-500, #6B7280)",
                                  fontSize: "14px",
                                },
                                maxLength: 50,
                                inputMode: "text",
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: "#6B7280",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  // marginTop:"2px",
                                  "&.MuiFormLabel-filled": {
                                    color: "#111827",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                  },
                                },
                              }}
                            />
                          )}
                        </div>

                        <div className={ProfileStyles.textFeildWrapper}>
                          <TextField
                            className={ProfileStyles.textfield}
                            id="outlined-basic"
                            label="Mother's Full Name"
                            variant="outlined"
                            name="motherFullName"
                            value={
                              values.motherFullName &&
                              values.motherFullName.toUpperCase()
                            }
                            error={
                              touched.motherFullName &&
                              Boolean(errors.motherFullName)
                            }
                            helperText={
                              touched.motherFullName &&
                              errors.motherFullName?.toString()
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "#111827",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                },
                                color: "var(--Black-Black-500, #6B7280)",
                                fontSize: "14px",
                              },
                              maxLength: 50,
                              inputMode: "text",
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                borderRadius: "100px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "#6B7280",
                                fontWeight: 400,
                                fontSize: "14px",
                                "&.MuiFormLabel-filled": {
                                  color: "#111827",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                },
                              },
                            }}
                          />
                        </div>
                      </div>

                      <div className={ProfileStyles.topContainer}>
                        <div className={ProfileStyles.textFeildWrapper}>
                          <CommonDropdown
                            LabelName="Are You Politically Exposed"
                            menuItems={politicallyExposed}
                            name="areYouPoliticallyExposed"
                            value={values.areYouPoliticallyExposed}
                            handleChange={handleChange}
                            error={
                              touched.areYouPoliticallyExposed &&
                              Boolean(errors.areYouPoliticallyExposed)
                            }
                            helperText={
                              touched.areYouPoliticallyExposed &&
                              errors.areYouPoliticallyExposed
                            }
                            setOthers={""}
                          />
                        </div>
                        <div className={ProfileStyles.textFeildWrapper}>
                          <CommonDropdown
                            LabelName="Marital Status"
                            menuItems={maritalStatus}
                            name="maritalStatus"
                            value={values.maritalStatus}
                            handleChange={handleChange}
                            error={
                              touched.maritalStatus &&
                              Boolean(errors.maritalStatus)
                            }
                            helperText={
                              touched.maritalStatus && errors.maritalStatus
                            }
                            setOthers={""}
                          />
                        </div>
                      </div>
                      <div className={ProfileStyles.topContainer}>
                        <div className={ProfileStyles.textFeildWrapper}>
                          <CommonDropdown
                            LabelName="Gender"
                            menuItems={Gender}
                            name="gender"
                            value={values.gender}
                            handleChange={handleChange}
                            error={touched.gender && Boolean(errors.gender)}
                            helperText={touched.gender && errors.gender}
                            setOthers={""}
                          />
                        </div>
                        <div className={ProfileStyles.textFeildWrapper}>
                          <CommonDropdown
                            LabelName="Trading Experience"
                            menuItems={tradingExperienceOptions}
                            name="tradingExperience"
                            value={values.tradingExperience}
                            handleChange={handleChange}
                            error={
                              touched.tradingExperience &&
                              Boolean(errors.tradingExperience)
                            }
                            helperText={
                              touched.tradingExperience &&
                              errors.tradingExperience
                            }
                            setOthers={""}
                          />
                        </div>
                        {/* <div className={ProfileStyles.subRightContainer}>
                          <Typography
                            fontSize={"18px"}
                            color={"#000000"}
                            sx={{ paddingLeft: "7px", paddingBottom: "10px" }}
                          >
                            Your annual income
                          </Typography>
                          <SelectDropdown
                            LabelName="Annual Income"
                            menuItems={annualIncomeOptions}
                            name="annualIncome"
                            value={values.annualIncome}
                            handleChange={handleChange}
                            error={
                              touched.annualIncome &&
                              Boolean(errors.annualIncome)
                            }
                            helperText={
                              touched.annualIncome && errors.annualIncome
                            }
                            setOthers={setOccupationOthers}
                          />
                        </div> */}
                      </div>
                      <div className={ProfileStyles.topContainer}>
                        <div className={ProfileStyles.textFeildWrapper}>
                          <CommonDropdown
                            LabelName="Annual Income"
                            menuItems={annualIncomeOptions}
                            name="annualIncome"
                            value={values.annualIncome}
                            handleChange={handleChange}
                            error={
                              touched.annualIncome &&
                              Boolean(errors.annualIncome)
                            }
                            helperText={
                              touched.annualIncome && errors.annualIncome
                            }
                            setOthers={""}
                          />
                        </div>
                        <div className={ProfileStyles.textFeildWrapper}>
                          <CommonDropdown
                            LabelName="Occupation"
                            menuItems={occupationOptions}
                            name="occupation"
                            value={values.occupation}
                            handleChange={handleChange}
                            error={
                              touched.occupation && Boolean(errors.occupation)
                            }
                            helperText={touched.occupation && errors.occupation}
                            setOthers={setOthersData}
                          />
                        </div>
                      </div>
                      {occupationOther === "Others" && (
                        <div className={ProfileStyles.topContainer}>
                          <div className={ProfileStyles.textFeildWrapper}>
                            <TextField
                              id="outlined-basic"
                              label="Enter Your Occupation"
                              variant="outlined"
                              name="occupationIfOthers"
                              value={values.occupationIfOthers.toUpperCase()}
                              error={
                                touched.occupationIfOthers &&
                                Boolean(errors.occupationIfOthers)
                              }
                              helperText={
                                touched.occupationIfOthers &&
                                errors.occupationIfOthers?.toString()
                              }
                              className={ProfileStyles.textfield}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              inputProps={{
                                sx: {
                                  "&::label": {
                                    fill: "#111827",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                  },
                                  color: "var(--Black-Black-500, #6B7280)",
                                  fontSize: "14px",
                                },
                                maxLength: 50,
                                inputMode: "text",
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: "#6B7280",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  "&.MuiFormLabel-filled": {
                                    color: "#111827",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                  },
                                },
                              }}
                            />
                          </div>
                          <div
                            className={ProfileStyles.textFeildWrapper}
                            style={{ visibility: "hidden" }}
                          >
                            <TextField
                              id="outlined-basic"
                              label="Enter Your Occupation"
                              variant="outlined"
                              name="occupationIfOthers"
                              value={values.occupationIfOthers.toUpperCase()}
                              error={
                                touched.occupationIfOthers &&
                                Boolean(errors.occupationIfOthers)
                              }
                              helperText={
                                touched.occupationIfOthers &&
                                errors.occupationIfOthers?.toString()
                              }
                              className={ProfileStyles.textfield}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              inputProps={{
                                sx: {
                                  "&::label": {
                                    fill: "#111827",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                  },
                                  color: "var(--Black-Black-500, #6B7280)",
                                  fontSize: "14px",
                                },
                                maxLength: 50,
                                inputMode: "text",
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: "#6B7280",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  "&.MuiFormLabel-filled": {
                                    color: "#111827",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                  },
                                },
                              }}
                            />
                          </div>
                        </div>
                      )}

                      <div className={ProfileStyles.buttonStack}>
                        {values.areYouPoliticallyExposed &&
                        values.fatherFullName &&
                        values.motherFullName &&
                        values.annualIncome &&
                        values.occupation &&
                        values.maritalStatus &&
                        values.tradingExperience &&
                        values.gender &&
                        // values.settlements &&
                        (values.occupation.value === "Others"
                          ? Boolean(values.occupationIfOthers)
                          : true) &&
                        !errors.fatherFullName &&
                        !errors.motherFullName ? (
                          <LoadingButton
                            loading={loading}
                            variant="contained"
                            type="submit"
                            id="yourProfileContinueButton"
                            onClick={() => {
                              handleSubmit();
                            }}
                            className={ProfileStyles.approveButton}
                            sx={{ height: "50px" }}
                          >
                            Continue
                          </LoadingButton>
                        ) : (
                          <Button
                            variant="contained"
                            disabled
                            sx={{ height: "50px" }}
                            onClick={() => {
                              handleSubmit();
                            }}
                            className={ProfileStyles.approveButton}
                          >
                            Continue
                          </Button>
                        )}

                        {/* <div className={ProfileStyles.startOverSection}>
                          <img src={icon} className={ProfileStyles.iconImage} />
                          <p className={ProfileStyles.paratext}>
                            {" "}
                            if the above mentioned info not yours
                            <span
                              className={ProfileStyles.startoverbutton}
                              onClick={handleStartOver}
                            >
                              Start Over
                            </span>
                          </p>
                        </div> */}
                      </div>
                    </div>
                  </form>
                );
              }}
            </Formik>
          ) : (
            <div style={{ height: "80vh" }}>
              <BackDrop />
            </div>
          )}
        </div>
      </div>

      <PloiticalModal openModal={openModal} handleDone={handleDone} />
    </div>
  );
}
